import React from 'react';
import { MaterialIcons } from '@iclinic/design-system';

import { buttonsTitle } from 'features/video-conference/constants';
import ToggleButton from 'features/video-conference/components/TeamComponents/ToggleButton';
import { useChatContext } from 'features/video-conference/state/chatContext';
import { useAnnotationContext } from 'features/video-conference/state/annotationContext';
import { useConference } from 'features/video-conference/state/conferenceContext';

const { EditNote } = MaterialIcons;

export default function AnnotationsButton() {
  const { setIsBackgroundSelectionOpen } = useConference();
  const { setIsChatWindowOpen } = useChatContext();

  const { isAnnotationWindowOpen, setIsAnnotationWindowOpen } =
    useAnnotationContext();

  const toggleAnnotationWindow = () => {
    setIsChatWindowOpen(false);
    setIsBackgroundSelectionOpen(false);
    setIsAnnotationWindowOpen(!isAnnotationWindowOpen);
  };

  return (
    <ToggleButton
      onClick={toggleAnnotationWindow}
      switchedOn
      variant="info"
      updateOn={false}
      title={buttonsTitle.ANNOTATIONS}
      label={buttonsTitle.ANNOTATIONS}
      icon={<EditNote />}
      aria-controls={buttonsTitle.ANNOTATIONS}
      dataGa="telemedicine_annotations"
      dataSp="telemedicine_annotations"
    />
  );
}
